import styled from 'styled-components';

export const Wrapper = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
`;
